enum ActionType {
    REQUEST_WAS = '[DASHBOARD/WAS_VALUE] GET VALUE',
    RECEIVE_WAS = '[DASHBOARD/WAS_VALUE] SET VALUE',
    WAS_REQUEST_FAILED = '[DASHBOARD/WAS_VALUE] REQUEST FAILED',
}

export default ActionType
